module.exports = __webpack_public_path__ + "img/mobile.5c3844.png";